import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=6dcd64e8&scoped=true&"
import script from "./DateQuestion.vue?vue&type=script&lang=js&"
export * from "./DateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DateQuestion.vue?vue&type=style&index=0&id=6dcd64e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd64e8",
  null
  
)

export default component.exports